import BookingForm from "./BookingForm";

function BookingModal({ vehicle, onClose, setMessage, message }) {
  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="fixed top-1/2 left-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 transform overflow-hidden rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-black/10">
        <h2 className="text-xl font-semibold mb-4">
          Book: <span className="text-blue-700">{vehicle.model}</span>
        </h2>
        <BookingForm
          vehicle={vehicle}
          onClose={onClose}
          setMessage={setMessage}
          message={message}
        />
      </div>
    </>
  );
}

export default BookingModal;
